module.exports = require("core-js/library/fn/parse-int");


//////////////////
// WEBPACK FOOTER
// /Users/jeff/Projects/git/react-github-corner/node_modules/@babel/runtime-corejs2/core-js/parse-int.js
// module id = 251
// module chunks = 0